import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractRadioInput} from "../abstract-radio-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterRadioInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-radio-input",
    styleUrls: ["./filter-radio-input.component.scss"],
    templateUrl: "./filter-radio-input.component.html",
    standalone: false
})
export class FUIFilterRadioInputComponent extends FUIAbstractRadioInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
